import { render, staticRenderFns } from "./FolderRelaunchEmailDialog.vue?vue&type=template&id=3a8ee506&scoped=true"
import script from "./FolderRelaunchEmailDialog.vue?vue&type=script&lang=js"
export * from "./FolderRelaunchEmailDialog.vue?vue&type=script&lang=js"
import style0 from "./FolderRelaunchEmailDialog.vue?vue&type=style&index=0&id=3a8ee506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8ee506",
  null
  
)

export default component.exports